// PHA-1168 Reports: a report's `#handle` as a click-to-copy chip. Typing the
// handle in Ask Phanova runs the report.
import React from 'react';
import { toast } from 'react-hot-toast';

const HandleChip: React.FC<{ handle: string }> = ({ handle }) => {
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(`#${handle}`);
      toast.success(`Copied #${handle}`);
    } catch {
      toast.error('Could not copy. Select the handle and copy it by hand.');
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      title={`Use in Ask Phanova: #${handle} (click to copy)`}
      aria-label={`Copy #${handle}`}
      className="rounded px-1.5 py-0.5"
      style={{
        border: '1px solid #bae6fd', background: '#f0f9ff', color: '#0369a1', cursor: 'pointer',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 12,
      }}
    >
      #{handle}
    </button>
  );
};

export default HandleChip;
